<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="92%"
    top="5vh"
    custom-class="contact-form-dialog"
    append-to-body
    @closed="$emit('closed')"
  >
    <ContactFormBanner @submitted="onSubmitted" />
  </el-dialog>
</template>

<script>
import ContactFormBanner from "./ContactFormBanner.vue";

export default {
  name: "ContactFormModal",
  components: { ContactFormBanner },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    onSubmitted() {
      this.innerVisible = false;
    },
  },
};
</script>

<style lang="scss">
.contact-form-dialog {
  max-width: 1240px;
  border-radius: 16px;
  overflow: hidden;

  .el-dialog__header {
    padding: 12px 12px 0;
    border-bottom: none;
  }

  .el-dialog__title {
    display: none;
  }

  .el-dialog__headerbtn {
    top: 12px;
    right: 12px;
    z-index: 2;
  }

  .el-dialog__body {
    padding: 12px 20px 24px;
    background: $box-bg;
  }
}
</style>
